import { CriteriaInstance } from "types/Checklist";

export const useShouldIncludeChecklistCriteriaCheckmark = (
  criteriaInstance: CriteriaInstance,
  includeCriteriaCheckmarks: boolean,
  isStudentMode: boolean = false
) => {
  if (!includeCriteriaCheckmarks) return false;
  if (!isStudentMode) return true;

  if (criteriaInstance.isStudentMarkedComplete === true) return true;

  return Object.values(
    criteriaInstance.isStudentMarkedPositionComplete ?? {}
  ).some((isComplete) => isComplete === true);
};
